'use client';

import { useMemo } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { AppBar, Stack, Box, Toolbar } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { ROUTES } from '@/utils/constants';
import BodyStrong from '@/components/typography/BodyStrong';
type RouteItem = {
  text: string;
  link: string;
};
const ProfileMobileNavigator = () => {
  const routeItems: RouteItem[] = [{
    text: 'اطلاعات کاربری',
    link: '/dashboard/user-information'
  }, {
    text: 'دعوت دوستان',
    link: '/dashboard/referrals'
  }, {
    text: 'تراکنش‌ها',
    link: '/dashboard/user-transactions'
  }, {
    text: 'گزارش تخلف طرح به فرا بورس',
    link: '/dashboard/user-reports'
  }, {
    text: 'پشتیبانی',
    link: '/dashboard/support'
  }, {
    text: 'خروج',
    link: '/logout'
  }, {
    text: 'اطلاعات کاربری',
    link: '/dashboard'
  }, {
    text: 'سرمایه‌گذاری در',
    link: '/payment'
  }, {
    text: 'سرمایه‌گذاری در',
    link: '/successful-completion'
  }];
  const pathname = usePathname();
  const router = useRouter();
  const activeIndex = useMemo(() => {
    return routeItems.findIndex(route => pathname?.includes(route.link));
  }, [pathname]);
  const handleBackClick = () => {
    if (pathname === ROUTES.dashboard.root.href) {
      router.push('/');
    } else {
      router.back();
    }
  };
  return <AppBar position='fixed' data-sentry-element="AppBar" data-sentry-component="ProfileMobileNavigator" data-sentry-source-file="ProfileMobileNavigator.tsx">
      <Toolbar data-sentry-element="Toolbar" data-sentry-source-file="ProfileMobileNavigator.tsx">
        <Stack sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }} data-sentry-element="Stack" data-sentry-source-file="ProfileMobileNavigator.tsx">
          <Box onClick={handleBackClick} sx={{
          color: 'text.text',
          cursor: 'pointer'
        }} data-sentry-element="Box" data-sentry-source-file="ProfileMobileNavigator.tsx">
            <ArrowForward data-sentry-element="ArrowForward" data-sentry-source-file="ProfileMobileNavigator.tsx" />
          </Box>
          <Stack sx={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%'
        }} data-sentry-element="Stack" data-sentry-source-file="ProfileMobileNavigator.tsx">
            <BodyStrong padding={1.5} data-sentry-element="BodyStrong" data-sentry-source-file="ProfileMobileNavigator.tsx">
              {routeItems[activeIndex]?.text}
            </BodyStrong>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>;
};
export default ProfileMobileNavigator;